import NotificationManager from '../../components/common/react-notifications/NotificationManager'

export const NEWS_LOADING = 'NEWS_LOADING'

export const setLoadingNewsAction = (loading) => (dispatch,) => dispatch({
	type: NEWS_LOADING,
	loading,
},)

export const newsCreateAction = (action, variables,) => async (dispatch,) => {
	try {
		dispatch(setLoadingNewsAction(true))
		const { data, } = await action({ variables, })
		dispatch(setLoadingNewsAction(false))
		return data.news.id
	} catch (e) {
		NotificationManager.error(
			e.message || '',
			'Проблема создания',
			3000,
			null,
			null,
		)
		dispatch(setLoadingNewsAction(false))
		return null
	}
}

export const newsUpdateAction = (action, variables,) => async (dispatch,) => {
	try {
		dispatch(setLoadingNewsAction(true))
		const { data, } = await action({ variables, })
		return data.film
	} catch (e) {
		NotificationManager.error(
			e.message || '',
			'Проблема Обновления',
			3000,
			null,
			null,
		)
		dispatch(setLoadingNewsAction(false))
	}
	dispatch(setLoadingNewsAction(false))
}
